(function(){
    'use strict'

    angular.module('app.periodos')
    .factory('PeriodosService', PeriodosService);

    PeriodosService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function PeriodosService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/periodos/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, periodoId){

            var url = apiSettings.apiBaseUrl + 'api/periodos/' + companiaId + '/' + periodoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(periodo){

            periodo.id = 0;
            periodo.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/periodos',  
                method: 'POST',  
                data: periodo
            });  
            return response;
        };

        function update(periodo){

            periodo.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/periodos',  
                method: 'PUT',  
                data: periodo
            });  
            return response;
        };

        function remove(periodo){

            periodo.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/periodos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: periodo
            });  
            return response;
        };

    };

})();